import * as api from '../../api/index.js';

export async function exportAnalyticsData() {
    const { data: { users, videos } } = await api.getAnalyticsData();

    const createdAt = t => new Date(t).toLocaleString().replaceAll(',', '');

    const usersCsv = createCsv(users,
        { username: "Username", dateOfBirth: "Age", gender: "Gender", ethnicity: "Ethnicity", community: "In GGC Community", roleType: "Role", createdAt: "Signed Up At" },
        { createdAt, dateOfBirth: dob => Math.floor((Date.now() - Date.parse(dob)) / (1000 * 60 * 60 * 24 * 365)) }
    );
    const videosCsv = createCsv(videos,
        { category: "Category", subCategory: "Subcategory", title: "Title", views: "Views", totLikes: "Likes", totDislikes: "Dislikes", createdAt: "Created At" },
        { createdAt }
    );

    sendCsv("User Data.csv", usersCsv);
    sendCsv("Video Data.csv", videosCsv);
}

/**
 * @param {Object[]} dataArray 
 * @param {{[key: string]: string}} columns
 * @param {{[key: string]: (v: any) => any}} mapper
 * @returns {string}
 */
function createCsv(dataArray, columns, mapper = {}) {
    const keys = Object.keys(columns);
    const values = dataArray.map(data => Object.entries(data))
        .map(entries => Object.fromEntries(entries.filter(entry => keys.includes(entry[0]))))
        .map(data => {
            const mappedData = {};
            keys.forEach(key => mappedData[key] = (mapper[key] ?? (v => v))(data[key]));
            return mappedData;
        })
        .map(data => Object.values(data).map(item => `"${item.toString().replaceAll('"', '""')}"`).join(','))
        .join('\n');

    return keys.map(k => columns[k]).join(',') + '\n' + values;
}

/**
 * @param {string} fileName 
 * @param {string} text 
 */
function sendCsv(fileName, text) {
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
    linkElement.setAttribute('download', fileName);
    linkElement.style.display = 'none';

    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
}